<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_products')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'product', true)"
                          @click="openModal()"
                          v-if="$can('create_crms')"
      />
    </app-page-top-section>

    <app-table
        id="shop-table"
        :options="options"
        :card-view="false"
        @reload="reloadShopTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-shop-create-edit-modal
        v-if="isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />
    <!--        :subPackage="subscriptionPackage"-->

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('shop-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
// import PackageCreateEditModal from "./PackageCreateEditModal";

import {SHOP_HOME} from "../../../Config/ApiUrl";
import ShopCreateEditModal from "./ShopCreateEditModal";
import ShopMixin from "../../Mixins/ShopMixin";
export default {
  name: "Shop",
  components: {ShopCreateEditModal},
  mixins: [ShopMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      isLocationCreateOpenModalActive: false,
      subscriptionPackage: [],
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    triggerActions(row, action, active) {
      console.log(row);
      this.subscriptionPackage = row;
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${SHOP_HOME}/${row.id}`;
        this.isModalActive = true;
      }
      else {
        this.getAction(row, action, active)
      }

    },
  }
}
</script>
